import { createSlice } from '@reduxjs/toolkit'

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    // Plain serializable menu data — MenuItem class instances live in
    // NavigationStore module scope (they have circular parent refs).
    rawItems: [],
    activeRoute: null,
  },
  reducers: {
    initNavigation(state, { payload }) {
      state.rawItems = payload
      state.activeRoute = null
    },
    activateRoute(state, { payload }) {
      state.activeRoute = payload
    },
  },
})

export const { initNavigation, activateRoute } = navigationSlice.actions
export default navigationSlice.reducer
